import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthCtx = createContext({ agency: null, loading: true });

export function AuthProvider({ children }) {
  const [agency, setAgency] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setAgency(data);
    } catch {
      setAgency(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setAgency({ ...data.agency, smtp_configured: Boolean(data.agency?.smtp_host) });
    return data.agency;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    setAgency({ ...data.agency, smtp_configured: false });
    return data.agency;
  };

  const logout = async () => {
    await api.post("/auth/logout");
    setAgency(null);
  };

  return (
    <AuthCtx.Provider value={{ agency, loading, login, register, logout, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  return String(detail);
}
